import type { QueryClient } from "@tanstack/react-query";

/**
 * Invalidate every query that depends on a user's verification state.
 * Call after a verification payment succeeds or a subscription is cancelled
 * so the dashboard reflects the new state immediately (badge, sidebar,
 * gated features, history, subscription summary).
 */
export function invalidateVerificationQueries(
  queryClient: QueryClient,
  userId?: string | null,
) {
  const keys: (string | (string | undefined | null)[])[] = [
    ["isUserVerified", userId],
    ["userVerification", userId],
    ["verifiedArtistPrivileges", userId],
    ["verifiedArtistPrivileges"],
    ["lastVerificationRequest", userId],
    ["verificationSubscription", userId],
    ["verificationHistory", userId],
    ["userRole", userId],
    ["publicProfile"],
    ["publicProfile", userId],
  ];
  for (const key of keys) {
    queryClient.invalidateQueries({ queryKey: key as any });
  }
}
